module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/companies/company-logo-20-3331a7ce271b709ea781dee96071042e.png";